import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from '../../CustomSingleSelect';
import { MeetingCompanyTypeEnum, WelcomeStatusEnum } from '../../../models/common/Enums';
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { AddCompanyRequest } from '../../../models/request/company/AddCompanyRequest';
import { AddCompanyResponse } from '../../../models/response/company/AddCompanyResponse';
import { CompanyService } from '../../../services/CompanyService';
import { AddDriverRequest } from '../../../models/request/driver/AddDriverRequest';
import { AddDriverResponse } from '../../../models/response/driver/AddDriverResponse';
import { DriverService } from '../../../services/DriverService';
import CustomTextInput from '../../CustomTextInput';
import { Helpers } from '../../../helpers/Helpers';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { VehicleService } from '../../../services/VehicleService';
import { GetVehicleByIdResponse } from '../../../models/response/vehicle/GetVehicleByIdResponse';
import { GetDriverByIdResponse } from '../../../models/response/driver/GetDriverByIdResponse';
import { GetCompanyByIdResponse } from '../../../models/response/company/GetCompanyByIdResponse';
import Box from '../../Box';
import DriverMrzNfc from '../../DriverMrzNfc';

interface Props {
    antrepoOfferRefNo: string | undefined
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCustomer: CustomSingleSelectModel | undefined
    setSelectedCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSupplier: CustomSingleSelectModel | undefined
    setSelectedSupplier: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedRepresentative: CustomSingleSelectModel | undefined
    setSelectedRepresentative: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDriver: CustomSingleSelectModel | undefined
    setSelectedDriver: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    containerNo: string | undefined
    setContainerNo: React.Dispatch<React.SetStateAction<string | undefined>>
    vehicleArriveDate: string | undefined
    setVehicleArriveDate: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedWelcomeStatus: CustomSingleSelectModel | undefined
    setSelectedWelcomeStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedTrailer: CustomSingleSelectModel | undefined
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedVehicle: CustomSingleSelectModel | undefined
    setSelectedVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setWelcomeStatusToDefault: (showLoading: boolean, _enum: WelcomeStatusEnum) => Promise<void>
    saveVehicleOrTrailer: (_insertedValue: string, _isVehicle: number, _isTrailer: number, _setFunction: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>) => Promise<void>
    antrepoIncomingDate: string | undefined
    isPartialDisabled: boolean
    antrepoOfferRefNo2: string | undefined
    selectedIsInOut: CustomSingleSelectModel | undefined
    setSelectedIsInOut: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    welcomeId: string | undefined
}

const CommonWelcomeGeneralInformation = ({
    antrepoOfferRefNo,
    refNo,
    setRefNo,
    selectedCustomer,
    setSelectedCustomer,
    selectedSupplier,
    setSelectedSupplier,
    selectedRepresentative,
    setSelectedRepresentative,
    selectedDriver,
    setSelectedDriver,
    containerNo,
    setContainerNo,
    setVehicleArriveDate,
    vehicleArriveDate,
    selectedWelcomeStatus,
    setSelectedWelcomeStatus,
    selectedTrailer,
    setSelectedTrailer,
    selectedVehicle,
    setSelectedVehicle,
    setWelcomeStatusToDefault,
    saveVehicleOrTrailer,
    antrepoIncomingDate,
    isPartialDisabled,
    antrepoOfferRefNo2,
    selectedIsInOut,
    setSelectedIsInOut,
    welcomeId
}: Props) => {
    const dispatch = useDispatch();

    const saveCustomerOrSupplierOrRepresentative = async (_insertedValue: string, _isCustomer: number, _isSupplier: number, _isRepresentative: number, _setFunction: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>) => {
        try {
            dispatch(storeActivityIndicator(true));

            var initialCompanyTypeId: CustomSingleSelectModel | undefined = undefined;

            if (_isCustomer == 1) {
                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, MeetingCompanyTypeEnum.POTANSIYEL_MUSTERI);

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    initialCompanyTypeId = { label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 };
                }
            }

            if (_isRepresentative == 1) {
                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, MeetingCompanyTypeEnum.CALISILAN_MUSTERI);

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    initialCompanyTypeId = { label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 };
                }
            }

            var obj: AddCompanyRequest = {
                companyId: undefined,
                initialCompanyTypeId: initialCompanyTypeId?.value,
                name: _insertedValue,
                companyAddresses: [],
                companyAuthorizedPersons: [],
                isCustomer: _isRepresentative || _isCustomer,
                isSupplier: _isSupplier,
                isRepresentative: _isRepresentative,
                isAgency: 0,
                isSenderFirm: 0,
                isReceiverFirm: 0,
                isDutyFirm: 0,
                isAirlineFirm: 0,
                isSeawayFirm: 0,
                isCompany: 0,
                companyBanks: [],
                fileArchives: [],
                isBlocked: 0,
                isCustomActive: 1,
                longName: _insertedValue,
                isWithholding: 0
            }

            var response: AddCompanyResponse = await CompanyService.addCompany(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)
            _setFunction({ label: response.data.name, value: response.data.companyId })
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveDriver = async (_insertedValue: string) => {
        if (_insertedValue.trim().split(' ').length == 1) {
            toast.error('Geçerli bir sürücü adı soyadı giriniz!')
        }
        else {
            try {
                var name = "";
                var surname = undefined;

                var splitted = _insertedValue.replaceAll('  ', ' ').trim().split(' ');

                surname = splitted.pop();
                name = splitted.join(' ');

                dispatch(storeActivityIndicator(true));

                var obj: AddDriverRequest = {
                    driverId: undefined,
                    isCustomActive: 1,
                    name: name,
                    relatedCompanyId: selectedSupplier?.value,
                    surname: surname,
                    periodicalDocuments: [],
                    fileArchives: []
                }

                var response: AddDriverResponse = await DriverService.addDriver(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    return;
                }

                toast.success(response.message)
                setSelectedDriver({ label: response.data.nameSurname, value: response.data.driverId });
            } catch (error: any) {
                toast.error(error);
            }
            finally {
                dispatch(storeActivityIndicator(false));
            }
        }
    }

    const onVehicleChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));
            if (selectedValue) {
                var response4: GetVehicleByIdResponse = await VehicleService.getVehicleById(selectedValue.value);

                if (!response4.isSuccess) {
                    toast.error(response4.message)
                    return;
                }

                var vehicle = response4.data;

                if (vehicle) {
                    if (vehicle.trailerId) {
                        var response3: GetVehicleByIdResponse = await VehicleService.getVehicleById(vehicle.trailerId);

                        if (!response3.isSuccess) {
                            toast.error(response3.message)
                            return;
                        }

                        var selectedTrailer = response3.data;

                        if (selectedTrailer)
                            setSelectedTrailer({ label: selectedTrailer.plate, value: selectedTrailer.vehicleId });
                        else
                            setSelectedTrailer(undefined)
                    }
                    else
                        setSelectedTrailer(undefined)

                    if (vehicle.driverId) {
                        var response2: GetDriverByIdResponse = await DriverService.getDriverById(vehicle?.driverId);

                        if (!response2.isSuccess) {
                            toast.error(response2.message)
                            return;
                        }

                        var selectedDriver = response2.data;

                        if (selectedDriver && selectedDriver.nameSurname && selectedDriver.driverId)
                            setSelectedDriver({ label: selectedDriver.nameSurname, value: selectedDriver.driverId });
                        else
                            setSelectedDriver(undefined)
                    }
                    else
                        setSelectedDriver(undefined)

                    if (vehicle.vehicleOwnerId) {
                        var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(vehicle?.vehicleOwnerId);

                        if (!response.isSuccess) {
                            toast.error(response.message)
                            return;
                        }

                        var selectedSupplier = response.data;

                        if (selectedSupplier && selectedSupplier.name)
                            setSelectedSupplier({ label: selectedSupplier.name, value: selectedSupplier.companyId });
                        else
                            setSelectedSupplier(undefined)
                    }
                    else
                        setSelectedSupplier(undefined)
                }
                else {
                    setSelectedTrailer(undefined)
                    setSelectedDriver(undefined)
                    setSelectedSupplier(undefined)
                }
            }
            else {
                setSelectedTrailer(undefined)
                setSelectedDriver(undefined)
                setSelectedSupplier(undefined)
            }

            setSelectedVehicle(selectedValue);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    return (
        <div>
            <KTCard className="ebbe-card">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    {
                        antrepoOfferRefNo && (
                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bağlı Teklif Ref No</label>
                                        <CustomTextInput isDisabled value={Helpers.isEmpty(antrepoOfferRefNo) ? antrepoOfferRefNo2 : antrepoOfferRefNo} />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Müşteri</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCustomer}
                                            onChange={setSelectedCustomer}
                                            insertable={selectedCustomer ? undefined : {
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveCustomerOrSupplierOrRepresentative(_insertedValue, 1, 0, 0, setSelectedCustomer);
                                                    }
                                                }
                                            }}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCustomer: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Mümessil</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedRepresentative}
                                            onChange={setSelectedRepresentative}
                                            insertable={selectedRepresentative ? undefined : {
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveCustomerOrSupplierOrRepresentative(_insertedValue, 0, 0, 1, setSelectedRepresentative);
                                                    }
                                                }
                                            }}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCustomer: true }),
                                                () => CompanyService.getCompanyList({ isRepresentative: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    {/* <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">İşlem Türü</label>

                                        <CustomSingleSelect
                                            onChange={setSelectedIsInOut}
                                            selectedValue={selectedIsInOut}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: [
                                                        { label: 'Antrepo Tahliye', value: 'isOut' },
                                                        { label: 'Antrepo Yükleme', value: 'isIn' },
                                                    ]
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div> */}
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">İşlem Durumu</label>

                                        <CustomSingleSelect
                                            disabled={isPartialDisabled}
                                            selectedValue={selectedWelcomeStatus}
                                            onChange={setSelectedWelcomeStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('WELCOME_STATUS')}
                                            labelName='value'
                                            valueName="constantId"
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {
                        !antrepoOfferRefNo && (
                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                        <CustomTextInput isDisabled value={refNo} setValue={setRefNo} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Plaka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicle}
                                            onChange={onVehicleChange}
                                            onMenuOpen={() => VehicleService.getVehicleList(["2", "4", "5"])}
                                            insertable={{
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveVehicleOrTrailer(_insertedValue, 1, 0, setSelectedVehicle);
                                                    }
                                                }
                                            }}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Dorse Plaka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedTrailer}
                                            onChange={setSelectedTrailer}
                                            onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                            insertable={{
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveVehicleOrTrailer(_insertedValue, 0, 1, setSelectedTrailer);
                                                    }
                                                }
                                            }}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Sürücü</label>

                                        <Box flexDirection='row'>
                                            <Box flexGrow={1} justifyContent='center'>
                                                <CustomSingleSelect
                                                    selectedValue={selectedDriver}
                                                    onChange={setSelectedDriver}
                                                    insertable={{
                                                        onSubmit: {
                                                            onSubmit: (_insertedValue) => {
                                                                saveDriver(_insertedValue);
                                                            }
                                                        }
                                                    }}
                                                    onMenuOpen={() => DriverService.getDriverList()}
                                                    labelName='nameSurname'
                                                    valueName='driverId'
                                                />
                                            </Box>

                                            <DriverMrzNfc
                                                closeLoadingAfter={true}
                                                callback={(response) => {
                                                    setSelectedDriver({ label: response.nameSurname, value: response.driverId });
                                                }}
                                            />
                                        </Box>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">İşlem Durumu</label>

                                        <CustomSingleSelect
                                            disabled={isPartialDisabled}
                                            selectedValue={selectedWelcomeStatus}
                                            onChange={setSelectedWelcomeStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('WELCOME_STATUS')}
                                            labelName='value'
                                            valueName="constantId"
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Müşteri</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCustomer}
                                            onChange={setSelectedCustomer}
                                            insertable={selectedCustomer ? undefined : {
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveCustomerOrSupplierOrRepresentative(_insertedValue, 1, 0, 0, setSelectedCustomer);
                                                    }
                                                }
                                            }}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCustomer: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Tedarikçi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedSupplier}
                                            onChange={setSelectedSupplier}
                                            insertable={selectedSupplier ? undefined : {
                                                onSubmit: {
                                                    onSubmit: (_insertedValue) => {
                                                        saveCustomerOrSupplierOrRepresentative(_insertedValue, 0, 1, 0, setSelectedSupplier);
                                                    }
                                                }
                                            }}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isSupplier: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Konteyner No</label>
                                        <CustomTextInput value={containerNo} setValue={setContainerNo} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Geliş Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={vehicleArriveDate} onChange={(e) => { setVehicleArriveDate(e.target.value); setWelcomeStatusToDefault(true, WelcomeStatusEnum.ARAC_GELDI); }} type="datetime-local" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        welcomeId && (
                                            <div className="mt-5">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Antrepoya Gelecek Tarih</label>
                                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={antrepoIncomingDate} type="datetime-local" className="form-control form-control-solid" />
                                            </div>
                                        )
                                    }
                                    {/* 
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bağlı Teklif Ref No</label>
                                        <CustomTextInput isDisabled value={Helpers.isEmpty(antrepoOfferRefNo) ? antrepoOfferRefNo2 : antrepoOfferRefNo} />
                                    </div> */}
                                </div>
                            </div>
                        )
                    }
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default CommonWelcomeGeneralInformation;